import { render } from "./NodejsQuickstartView.vue?vue&type=template&id=7c642f77"
import script from "./NodejsQuickstartView.vue?vue&type=script&lang=js"
export * from "./NodejsQuickstartView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__